import React from "react";
import { CardsWrapper } from "../../../Invitations/Dashboard/RSVP/styles";
import { Box, colors, Divider, Pagination, Typography } from "@mui/material";
import {
	INVITATION_STATUS,
	INVITATION_STATUSES,
	Invitations
} from "../../../../store/services/invitations/dto/invitations.dto";
import { StyleCircle } from "../../../../Components/Inputs/Settings/styles";
import { InvitationStatusColor } from "../../../../constants";
import { InvitationIdCellWrapper } from "../styles";
import { formatDate } from "../../../../utils/formatDate";
import TableRowMenu from "../../../../Components/MaterialTable/TableRowMenu";

const CardsList = ({
	data,
	setConfirmSuspend,
	setConfirmUnPublish,
	setConfirmPublish,
	setConfirmReject,
	setConfirmActionRequired,
	page,
	perPage,
	totalItems,
	onPageChange
}: {
	data: Invitations[];
	setConfirmPublish: React.Dispatch<React.SetStateAction<string | null>>;
	setConfirmReject: React.Dispatch<React.SetStateAction<string | null>>;
	setConfirmActionRequired: React.Dispatch<React.SetStateAction<string | null>>;
	setConfirmUnPublish: React.Dispatch<React.SetStateAction<string | null>>;
	setConfirmSuspend: React.Dispatch<React.SetStateAction<string | null>>;
	page: number;
	perPage: number;
	totalItems: number;
	onPageChange: (page: number) => void;
}) => {
	return (
		<CardsWrapper>
			{(data || []).map(item => (
				<Box key={item._id} className={"card"}>
					<Box my={1} display={"flex"} justifyContent={"space-between"} alignItems={"center"} px={1}>
						<Typography fontWeight={"bold"}>{item.name}</Typography>
						<Box display={"flex"} gap={1} alignItems={"center"}>
							<StyleCircle $color={InvitationStatusColor[item.status || 1]} />
							<Typography variant={"caption"}>{INVITATION_STATUSES[item.status]}</Typography>
						</Box>
					</Box>
					<Divider />
					<Box p={1} pb={0} display={"flex"} flexDirection={"column"} gap={1}>
						<InvitationIdCellWrapper to={`/manageWeddingInvitation/${item._id}`} target={"_blank"}>
							{item._id}
						</InvitationIdCellWrapper>
						<Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
							<Box display={"flex"} flexDirection={"column"} alignItems={"center"} gap={1}>
								<Typography>Views</Typography>
								<Typography>{item.responseStats?.total_views}</Typography>
							</Box>
							<Box display={"flex"} flexDirection={"column"} alignItems={"center"} gap={1}>
								<Typography>Responses</Typography>
								<Typography>{item.responseStats?.total}</Typography>
							</Box>
							<Box display={"flex"} flexDirection={"column"} alignItems={"center"} gap={1}>
								<Typography style={{ color: colors.green[800] }}>Accepted</Typography>
								<Typography style={{ color: colors.green[800] }}>{item.responseStats?.accepted}</Typography>
							</Box>{" "}
							<Box display={"flex"} flexDirection={"column"} alignItems={"center"} gap={1}>
								<Typography style={{ color: colors.red[800] }}>Declined</Typography>
								<Typography style={{ color: colors.red[800] }}>{item.responseStats?.declined}</Typography>
							</Box>
						</Box>
						<Divider />
						<Box display={"flex"} flexDirection={"column"}>
							<Typography>Owner:</Typography>
							<Box display={"flex"} gap={1}>
								<Typography>{item.user_id?.firstName}</Typography>
								<Typography>{item.user_id?.lastName}</Typography>
							</Box>
							<Typography>{item.user_id?.email}</Typography>
						</Box>
						<Divider />
						<Box className={"card-footer"}>
							<Typography>{formatDate(item.createdAt, item.timezone)}</Typography>
							<TableRowMenu
								items={[
									{
										label: "Publish",
										visible: item.status === INVITATION_STATUS.PENDING,
										onSelected: () => {
											setConfirmPublish(item._id);
										}
									},
									{
										label: "Reject",
										visible: item.status === INVITATION_STATUS.PENDING,
										onSelected: () => {
											setConfirmReject(item._id);
										}
									},
									{
										label: "Action Required",
										visible: item.status === INVITATION_STATUS.PENDING,
										onSelected: () => {
											setConfirmActionRequired(item._id);
										}
									},
									{
										label: "Un Publish",
										visible: item.status === INVITATION_STATUS.PUBLISHED,
										onSelected: () => {
											setConfirmUnPublish(item._id);
										}
									},
									{
										label: "Suspend",
										visible: item.status === INVITATION_STATUS.PUBLISHED,
										onSelected: () => {
											setConfirmSuspend(item._id);
										}
									}
								]}
							/>
						</Box>
					</Box>
				</Box>
			))}
			{!!(page && perPage && totalItems) && (
				<Box p={2} display={"flex"} justifyContent={"flex-end"}>
					<Pagination
						page={page}
						count={Math.ceil(totalItems / perPage)}
						shape="rounded"
						onChange={(event: unknown, newPage: number) => {
							onPageChange(newPage);
						}}
					/>
				</Box>
			)}
		</CardsWrapper>
	);
};

export default CardsList;
